import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddAudioApi, DeleteAudioApi, ListAudioApi, setDefaultAudioApi, UploadAudioFileApi } from "../../apis/AdminApis/AdminAudioApi";
import { showSnackbar } from "../../slices/SnackbarSlice";

export const uploadAudioFileAction = createAsyncThunk("admin/upload-audio-file", async (file: File, { rejectWithValue, dispatch }) => {
    try {
        const response = await UploadAudioFileApi(file);
        dispatch(showSnackbar({ message: response?.data?.message || "Audio uploaded successfully", type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Could not upload audio file", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not upload audio file" });
    }
});

export const addAudioAction = createAsyncThunk("admin/add-audio", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await AddAudioApi(payload);
        dispatch(showSnackbar({ message: response?.data?.message || "Audio added successfully", type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Could not add audio", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not add audio" });
    }
});

export const listAudioAction = createAsyncThunk("admin/list-audio", async (_, { rejectWithValue }) => {
    try {
        const response = await ListAudioApi();
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not list audio" });
    }
});

export const deleteAudioAction = createAsyncThunk("admin/delete-audio", async (id: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await DeleteAudioApi(id);
        dispatch(showSnackbar({ message: response?.data?.message || "Audio deleted successfully", type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Could not delete audio", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not delete audio" });
    }
});

export const setDefaultAudioAction = createAsyncThunk("admin/set-default-audio", async (audioId: string, { rejectWithValue, dispatch }) => {
    try {
        const response = await setDefaultAudioApi(audioId);
        dispatch(showSnackbar({ message: response?.data?.message || "Default audio set successfully", type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Could not set default audio", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not set default audio" });
    }
});
